export const SET_BENEFICIARY_DATA = "SET_BENEFICIARY_DATA";

export const RESET_LIFECHECK_DATA = "RESET_LIFECHECK_DATA";
export const SET_INHERITED_PORTFOLIO_DATA = "SET_INHERITED_PORTFOLIO_DATA";
